import { render } from "./workerStatus.vue?vue&type=template&id=bc89aa78"
import script from "./workerStatus.vue?vue&type=script&lang=js"
export * from "./workerStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__